import axios from 'axios';

import { FAVOURITE_PROPERTY_ENDPOINT } from '../consts';

export const toggleFavouriteProperty = ({
  id,
  csrfToken,
  eventType,
  onResponse = () => {},
  onError = () => {},
}) => {
  const payload = { entity_id: id, event_type: eventType };
  axios
    .post(FAVOURITE_PROPERTY_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

export const getFavouriteProperties = ({
  onResponse,
  onError,
}) => {
  axios.get(FAVOURITE_PROPERTY_ENDPOINT, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
  })
  .then(onResponse)
  .catch(onError);
}